<template>
    <!-- 食品追溯 -->
    <div class="inside_pages_right_top">
        <ul>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/food_materials'}"  @click="$Common.pageJump('/food_materials',3)">食品食材</li>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/sample_management'}" @click="$Common.pageJump('/sample_management',3)">留样管理</li>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/sampling_test'}" @click="$Common.pageJump('/sampling_test',3)">抽样检测</li>
        </ul>
    </div>
</template>

<script>
export default {
    name:'FoodTraceability',
    components: {},
    props: {},
    data() {
        return {
        };
    },
    watch: {
    },
    computed: {
    },
    methods: {
       
    },
    created() {
    },
    mounted() {
    },
};
</script>
<style scoped>
@import '/css/base.css';
@import '/css/authority.css';
</style>